import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(HttpApi) // Load ngôn ngữ từ file JSON
  .use(LanguageDetector) // Phát hiện ngôn ngữ
  .use(initReactI18next) // Tích hợp với React
  .init({
    supportedLngs: ["en", "vi"], // Các ngôn ngữ hỗ trợ
    fallbackLng: "vi", // Ngôn ngữ mặc định
    debug: true,
    interpolation: {
      escapeValue: false, // Không cần escape trong React
    },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json", // Đường dẫn file dịch
    },
  });

export default i18n;
